<router-outlet></router-outlet>
<div class="modal fade" id="NetsolinModal" role="dialog">
  <div class="modal-dialog" id="mdialTamanio" style="width: 75% !important;">
      <!-- Modal contenido-->
      <div class="modal-content">
          <div class="modal-header">
              <div class="pull-right">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
          </div>
          <div class="modal-body">
              <div id="Netmodalhtml">
              </div>
          </div>
          <div class="modal-footer">
          </div>
      </div>
  </div>
</div>
